import {initActions} from '@dized/ui/dist/redux/ActionHelper';
import {get} from '@dized/ui/dist/redux/RequestHelper';

export default initActions('AnalyticsActions', {
  /**
   * Fetch project analytics stats
   * @param {string} projectId - The project ID
   * @param {string} from - Start date (ISO string)
   * @param {string} to - End date (ISO string)
   * @returns {Promise} Promise that resolves to analytics data
   */
  GET_PROJECT_STATS: (projectId, from, to) => {
    console.log('🔍 GET_PROJECT_STATS action called for project:', projectId, 'from:', from, 'to:', to);
    
    // Build query parameters
    const params = { projectId };
    if (from) params.from = from;
    if (to) params.to = to;
    
    console.log('🔗 Using real API for project:', projectId);
    console.log('🔗 API endpoint: /api/v1/analytics/project/stats');
    console.log('🔗 API params:', params);
    
    // Directly return the get() result - Redux middleware handles the Promise
    return get('/api/v1/analytics/project/stats', params);
  },

  /**
   * Fetch project daily analytics stats
   * @param {string} projectId - The project ID
   * @param {string} from - Start date (ISO string)
   * @param {string} to - End date (ISO string)
   * @returns {Promise} Promise that resolves to daily analytics data
   */
  GET_PROJECT_DAILY_STATS: (projectId, from, to) => {
    console.log('🔍 GET_PROJECT_DAILY_STATS action called for project:', projectId, 'from:', from, 'to:', to);
    
    // Build query parameters
    const params = { projectId };
    if (from) params.from = from;
    if (to) params.to = to;
    
    console.log('🔗 Using daily stats API for project:', projectId);
    console.log('🔗 API endpoint: /api/v1/analytics/project/daily-stats');
    console.log('🔗 API params:', params);
    
    // Directly return the get() result - Redux middleware handles the Promise
    return get('/api/v1/analytics/project/daily-stats', params);
  }
});
